import { apiClient } from './client';
export const dropboxAuthApi = {
    /** Get the OAuth authorization URL to open in popup */
    initiate: async () => {
        return apiClient.get('/api/Auth/Dropbox/Initiate');
    },
    /** Check if user has connected their Dropbox account */
    getStatus: async () => {
        return apiClient.get('/api/Auth/Dropbox/Status');
    },
    /** Disconnect the user's Dropbox account */
    disconnect: async () => {
        return apiClient.delete('/api/Auth/Dropbox/Disconnect');
    },
};
